import $ from "jquery";
import bdjs from "@bd-core/bdjs";
import bdapi from "@bd-core/bd-api";

export const WelcomePage = () => {
    const isWelcomePage = $("#page-welcome").length > 0;
    if (!isWelcomePage) return false;

    bdjs.hideLoading();

    let isLoading = false;
    const submitCreateTeam = async function ($triggeredButton) {
        if (isLoading) return false;
        const $button = $triggeredButton;
        $button.addClass("is-loading").prop("disabled", true);
        $snackBar.removeClass("is-active");

        isLoading = true;

        const [res] = await bdjs.goAsync(
            bdapi.post("public/create-new-team", {
                user_email: $(".js-login-email").val(),
            }),
        );

        isLoading = false;
        const restData = res?.data || {};

        if (restData?.data?.redirect) {
            bdjs.showLoading();
            window.location.href = restData.data.redirect;
            return;
        }

        const msg =
            restData?.data?.message ||
            "Something went wrong. Please try again!";
        $button.removeClass("is-loading").removeAttr("disabled");
        $snackBar.addClass("is-active").find(".snackbar__body").html(msg);
    };

    const onInputLoginEmail = function () {
        const value = String($(this).val());
        const isDisabled = value.trim().length < 1;
        $(".welcome__formSubmit").prop("disabled", isDisabled);
    };

    $(".js-login-email").on("input", onInputLoginEmail);

    // Add Enter key listener to trigger submit button
    $(".js-login-email").on("keydown", function(e) {
        if (e.key === "Enter" || e.keyCode === 13) {
            e.preventDefault();
            const $submitBtn = $(".welcome__formSubmit");
            if (!$submitBtn.prop("disabled")) {
                $submitBtn.trigger("click");
            }
        }
    });

    const $snackBar = $(".snackbar");

    // Snackbar Component
    // ------------------------------------------------------------------------
    $snackBar.find(".snackbar__close").on("click", function (e) {
        e.preventDefault();
        $snackBar.removeClass("is-active");
    });

    $(".welcome__formSubmit").on("click", function (e) {
        e.preventDefault();
        const $this = $(this);
        submitCreateTeam($this);
        return false;
    });
};
